import store from '../store';
import visitorsAction from '../model/visitors/actions';
import { updateVisitors } from '../model/visitors/services';

const visitorsTask = () => updateVisitors().then((visitors) => {
  store.dispatch(visitorsAction.storeAll(visitors));
  return visitors;
});

export default visitorsTask;